/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { TextFormat, Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './patient-survey-sections.reducer';

export const PatientSurveySectionsDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const patientSurveySectionsEntity = useAppSelector(state => state.patientSurveySections.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="patientSurveySectionsDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.patientSurveySections.detail.title">PatientSurveySections</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.patientSurveySections.id">Id</Translate>
            </span>
          </dt>
          <dd>{patientSurveySectionsEntity.id}</dd>
          <dt>
            <span id="completedOn">
              <Translate contentKey="tinyMedicRestApp.patientSurveySections.completedOn">Completed On</Translate>
            </span>
          </dt>
          <dd>
            {patientSurveySectionsEntity.completedOn ? (
              <TextFormat value={patientSurveySectionsEntity.completedOn} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="completedByType">
              <Translate contentKey="tinyMedicRestApp.patientSurveySections.completedByType">Completed By Type</Translate>
            </span>
          </dt>
          <dd>{patientSurveySectionsEntity.completedByType}</dd>
          <dt>
            <span id="completedById">
              <Translate contentKey="tinyMedicRestApp.patientSurveySections.completedById">Completed By Id</Translate>
            </span>
          </dt>
          <dd>{patientSurveySectionsEntity.completedById}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.patientSurveySections.active">Active</Translate>
            </span>
          </dt>
          <dd>{patientSurveySectionsEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.patientSurveySections.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{patientSurveySectionsEntity.cursor}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.patientSurveySections.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{patientSurveySectionsEntity.lastupdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.patientSurveySections.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{patientSurveySectionsEntity.microSec}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.patientSurveySections.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{patientSurveySectionsEntity.timestampentry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.patientSurveySections.surveySection">Survey Section</Translate>
          </dt>
          <dd>{patientSurveySectionsEntity.surveySection ? patientSurveySectionsEntity.surveySection.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.patientSurveySections.patient">Patient</Translate>
          </dt>
          <dd>{patientSurveySectionsEntity.patient ? patientSurveySectionsEntity.patient.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.patientSurveySections.patientSurvey">Patient Survey</Translate>
          </dt>
          <dd>{patientSurveySectionsEntity.patientSurvey ? patientSurveySectionsEntity.patientSurvey.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/patient-survey-sections" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/patient-survey-sections/${patientSurveySectionsEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default PatientSurveySectionsDetail;
